if ("serviceWorker" in navigator) {
  const ua = navigator.userAgent.toLowerCase();

  if (location.hostname !== "kibe.la" && !ua.includes("iphone") && !ua.includes("ipad")) {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service worker registration succeeded:", registration);
      })
      .catch((error) => {
        console.warn("Service worker registration failed:", error);
      });
  }
}
